interface CalendarElement extends Element {
  year?: { calendar?: { updateSize: () => void } };
  month?: { calendar?: { updateSize: () => void } };
}

const updateSize = () =>
  Array.from(document.getElementsByClassName("calendar")).forEach((el) => {
    const calendarEl = el as CalendarElement;
    if (calendarEl.year?.calendar) {
      calendarEl.year.calendar.updateSize();
    }
    if (calendarEl.month?.calendar) {
      calendarEl.month.calendar.updateSize();
    }
  });

export default updateSize;
